import s from "styled-components";
import MetaCounter from "_c/MetaCounter";

export const Wrap = s.div`
  margin-top: 10px;
`;
export const Author = s.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  img {
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
  }
  span {
    color: var(--font-color-emp);
    font-weight: 600;
  }
`;
export const Timestamp = s.time`
  display: block;
  color: var(--font-color-emp);
  font-weight: 600;
  margin-top: 5px;
`;
export const Top = s.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  flex-wrap: wrap;
`;
export const Counters = s.div`
  display: flex;
  margin-top: 10px;
`;
export const CommentsMeta = s(MetaCounter)`
  margin-left: 0;
`;
